// extracted by mini-css-extract-plugin
export default {"wrapper":"FinalDialog_wrapper","align":"FinalDialog_align","margin":"FinalDialog_margin","content":"FinalDialog_content","entity":"FinalDialog_entity","spacer":"FinalDialog_spacer"};